export default __webpack_public_path__ + "static/media/burger.d05de4c4.svg";